<template>
    <v-container class="pa-0" fluid>
        <v-card class="pa-2">
            <v-card-title class="pt-0 pb-2 justify-center"><h2>Conversation Run Details</h2></v-card-title>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="12" class="pt-2 pb-6"><v-text-field v-model="search" label="Search run" single-line hide-details prepend-icon="mdi-magnify"></v-text-field></v-col>
            </v-row>
            <v-divider></v-divider>
            <v-data-table 
                :items="steps" 
                :items-per-page="10" 
                :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                :headers="headers"
                :search="search">
                <template v-slot:item="props">
                    <tr>
                        <td>{{ props.item.created_date }}</td>
                        <td>{{ props.item.type }}</td>
                        <td>{{ props.item.status }}</td>
                        <td>{{ props.item.usage.prompt_tokens }}</td>
                        <td>{{ props.item.usage.completion_tokens }}</td>
                        <td>{{ props.item.usage.total_tokens }}</td>
                        <td>
                             <!-- <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text 
                                        v-bind="attrs" 
                                        v-on="on"
                                        v-on:click="runDetails(props.item)"
                                        
                                        color="primary"
                                        >
                                        Details
                                    </v-btn>
                                </template>
                                <span>Mark as duplicate</span>
                            </v-tooltip> 
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        v-on:click="setToAssign(props.item)"
                                        class="button-margin-lr gridbutton">
                                        <v-icon small color="green">mdi-account-check-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Mark as not a duplicate</span>
                            </v-tooltip> 
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        x-small 
                                        text icon 
                                        v-bind="attrs" 
                                        v-on="on"
                                        v-on:click="assignPtenLead(props.item)"
                                        class="button-margin-lr gridbutton">
                                        <v-icon small>mdi-account-plus-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Assign lead <br> (not a duplicate)</span>
                            </v-tooltip>  -->
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        components: {
        },
        props: {
            conversation_id: {
                type: String,
                required: true,
            },
            run_id: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                search: "",

                steps: [],

                headers: [
                    {text: 'Created', value: 'created_date', tdClass: 'align-text-top'},
                    {text: 'Type', value: 'type', tdClass: 'align-text-top'},
                    {text: 'Status', value: 'status', tdClass: 'align-text-top'},
                    {text: 'Prompt tokens', value: 'usage.prompt_tokens', tdClass: 'align-text-top'},
                    {text: 'Completion tokens', value: 'usage.completion_tokens', tdClass: 'align-text-top'},
                    {text: 'Total tokens', value: 'usage.total_tokens', tdClass: 'align-text-top'},
                ],
            }
        },
        mounted() {
            this.getRunDetails();
        },
        methods: {
            actionClick(action) {
                switch (action) {
                    case "refresh":
                        break;
                }
            },
            updateData(data) {
                this.$emit("updateData", data);
            },
            getRunDetails() {
                this.$axios.post("ares/json/ares/syst/openai/getConversationRuns.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getConversationRuns"
                    },
                    getConversationRuns: {
                        thread_id: this.conversation_id,
                        run_id: this.run_id,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.steps = res.data.getConversationRuns.steps;
                    }
                });
            },
        }
    };
</script> 

<style scoped>
    .align-text-top {
        vertical-align: top;
    }
</style>
